module.exports = __webpack_public_path__ + "assets/img/m24.fb5bbce0.png";